import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';

import { useGetAnnouncementDetails } from '@web/announcements/hooks/useGetAnnouncementDetails';

type Props = {
  id: number;
};

export const useAnnouncementViewers = ({ id }: Props) => {
  const { users } = usePersonaCollection();
  const { data, isPlaceholderData } = useGetAnnouncementDetails(id);

  const readIds = data?.recipients.readIds;
  const viewers = useMemo(
    () => users.filter((user) => readIds.includes(user.id)),
    [readIds, users]
  );

  const hasEmptyData = data.recipients.read === 0;

  return {
    hasEmptyData,
    isLoading: isPlaceholderData && !hasEmptyData,
    viewers,
  };
};
